var __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"https://dash.bitesizehipaa.com/api"};